import React, { useContext, useState } from "react";
import { ChangePasswordContext } from "../ChangePasswordView";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import "./changePassword.css";
import { Container } from "react-bootstrap";
import GreenTickIcon from "../../../../assets/images/icons/green-tick-icon.svg";
import ExclamationIcon from "../../../../assets/images/icons/exclamation-icon.svg";
import PopupAlertSuccess from "../../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import { useNavigate } from "react-router-dom";
import routeConstants from "../../../../constants/routeConstants.json";
import { colors } from "@mui/material";

const ChangePassword = () => {
  const navigate = useNavigate();
  const {
    setCurrentPassword,
    setNewPassword,
    onChangeCurrentPassword,
    onChangeNewPassword,
    currentPassword,
    newPassword,
    handleOnSubmit,
    isMinLength,
    hasNumber,
    hasLowercase,
    hasUppercase,
    hasSpecialChar,
    isPrevPassword,
    showErrorPopup,
    setShowErrorPopup,
    alertMessage,
    confirmPassword,
    onChangeConfirmPassword,
    showSuccessPopup,
    setShowSuccessPopup,
    setConfirmPassBarColor,
    passwordValueNull,
    setCurrentPassColor,
    strengthBarMsg,
    confirmStrengthBarMsg,
    setStrengthBarMsg,
    samePasswordMsg,
    handleBlurConfirmPassword,

    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
  } = useContext(ChangePasswordContext);

  const navigateToProfile = () => {
    navigate(routeConstants.VIEW_PROFILE);
  };

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate(routeConstants.VIEW_PROFILE);
          }}
        >
          {ContentData.changePassword.profileManagement}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.changePassword.changePassword}
        </span>
      </div>
      <Container className="changePasswordContainer">
        <div className="changePasswordTitleBar">
          <div className="pageTittles">
            {ContentData.changePassword.changePassword}
          </div>
        </div>
        <div className="changePasswordDetails">
          <div className="changePasswordInputGrp">
            <div className="currentPasswordSpace cpInputElement">
              <span className="changePasswordLabel currentPassword">
                {ContentData.changePassword.currentPassword}
              </span>
              <InputComponent
                placeholder={
                  ContentData.changePassword.currentPasswordLowercase
                }
                onChange={onChangeCurrentPassword}
                value={currentPassword}
                type={"password"}
              />
            </div>

            <div className="newPasswordSpace cpInputElement">
              <span className="changePasswordLabel newPassword">
                {ContentData.changePassword.newPassword}
              </span>
              <div className="newPasswordInput">
                <InputComponent
                  placeholder={ContentData.changePassword.newPasswordlowercase}
                  onChange={onChangeNewPassword}
                  value={newPassword}
                  type={"password"}
                />
              </div>
              <div className="strengthBargrp">
                {[0, 1, 2].map((index) => (
                  <div
                    key={index}
                    className="strengthBar"
                    style={{ backgroundColor: setCurrentPassColor(index) }}
                  ></div>
                ))}
              </div>
              <div
                className="strengthBarMsg"
                style={{
                  color:
                    strengthBarMsg == "Strong"
                      ? "#13BC5B"
                      : strengthBarMsg == "Moderate"
                      ? "#EDB602"
                      : strengthBarMsg == "Weak"
                      ? "#EB5757"
                      : "#EB5757",
                }}
              >
                {strengthBarMsg}
              </div>
            </div>
            <div className="confirmNewPasswordSpace cpInputElement">
              <span className="changePasswordLabel confirmNewPassword">
                {ContentData.changePassword.confirmNewPassword}
              </span>
              <div className="confirmPasswordInput">
                <InputComponent
                  placeholder={
                    ContentData.changePassword.confirmNewPasswordLowercase
                  }
                  onChange={onChangeConfirmPassword}
                  value={confirmPassword}
                  type={"password"}
                  handleBlur={handleBlurConfirmPassword}
                />
              </div>
              <div className="strengthBargrp">
                {[0, 1, 2].map((index) => (
                  <div
                    key={index}
                    className="strengthBar"
                    style={{
                      backgroundColor: setConfirmPassBarColor(index),
                    }}
                  ></div>
                ))}
              </div>
              <div
                className="confirmStrengthBarMsg"
                style={{
                  color:
                    confirmStrengthBarMsg == "Strong"
                      ? "#13BC5B"
                      : confirmStrengthBarMsg == "Moderate"
                      ? "#EDB602"
                      : confirmStrengthBarMsg == "Weak"
                      ? "#EB5757"
                      : "#EB5757",
                }}
              >
                <span style={{ color: "#EB5757", fontSize: "12px" }}>
                  {samePasswordMsg}
                </span>
                {confirmStrengthBarMsg}
              </div>
            </div>
          </div>
          <div className="changePasswordGuidelines">
            <div className="guidelinesPanel">
              <div className="guidelineTitle">
                {ContentData.changePassword.passwordGuidelines}
              </div>
              <div className="guidelineItemGrp">
                <div className="guidelineItem">
                  <img
                    className="greenTickIcon"
                    src={isMinLength ? GreenTickIcon : ExclamationIcon}
                    alt={isMinLength ? "Green tick icon" : "Exclamation icon"}
                  />
                  {ContentData.changePassword.min8char}
                </div>
                <div className="guidelineItem">
                  <img
                    className="greenTickIcon"
                    src={hasNumber ? GreenTickIcon : ExclamationIcon}
                    alt={hasNumber ? "Green tick icon" : "Exclamation icon"}
                  />
                  {ContentData.changePassword.atleastOneNum}
                </div>
                <div className="guidelineItem">
                  <img
                    className="greenTickIcon"
                    src={hasLowercase ? GreenTickIcon : ExclamationIcon}
                    alt={hasLowercase ? "Green tick icon" : "Exclamation icon"}
                  />
                  {ContentData.changePassword.oneLowercase}
                </div>
                <div className="guidelineItem">
                  <img
                    className="exclamationIcon"
                    src={hasUppercase ? GreenTickIcon : ExclamationIcon}
                    alt={hasUppercase ? "Green tick icon" : "Exclamation icon"}
                  />
                  {ContentData.changePassword.oneUppercase}
                </div>
                <div className="guidelineItem">
                  <img
                    className="greenTickIcon"
                    src={hasSpecialChar ? GreenTickIcon : ExclamationIcon}
                    alt={
                      hasSpecialChar ? "Green tick icon" : "Exclamation icon"
                    }
                  />
                  {ContentData.changePassword.oneSpecialChar}
                </div>
                <div className="guidelineItem" style={{ width: "300px" }}>
                  <img
                    className="exclamationIcon"
                    src={isPrevPassword ? GreenTickIcon : ExclamationIcon}
                    alt={
                      isPrevPassword ? "Green tick icon" : "Exclamation icon"
                    }
                  />
                  {ContentData.changePassword.passwordNotSame}{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="changePasswordBtnGrp">
          <BorderButton
            value={ContentData.changePassword.cancel}
            className="changePasswordBtn"
            onClick={navigateToProfile}
          />
          <ThemeButton
            value={ContentData.changePassword.submit}
            className="changePasswordBtn"
            type={"submit"}
            id={"changePasswordSubmit"}
            onClick={handleOnSubmit}
            // disabled={true}
          />
        </div>
        <PopupAlertError
          show={showErrorPopup}
          setShow={setShowErrorPopup}
          alertMessage={alertMessage}
          handleCancel={() => {
            setShowErrorPopup(false);
            // navigate(routeConstants.VIEW_PROFILE);
          }}
          handleSubmit={() => {
            if (statusValue === 401 || statusValue === 403) {
              goToLogin();
              setShowErrorPopup(false);
            } else {
              setShowErrorPopup(false);
              document.getElementById("changePasswordSubmit").click();
            }
          }}
          buttonText={buttonText}
          cancelText="Close"
        />

        <PopupAlertSuccess
          show={showSuccessPopup}
          setShow={setShowSuccessPopup}
          alertMessage={alertMessage}
          handleSubmit={() => {
            setShowSuccessPopup(false);
            passwordValueNull();
            setStrengthBarMsg("");
            navigate(routeConstants.VIEW_PROFILE);
          }}
        />
      </Container>
    </div>
  );
};

export default ChangePassword;
